module.exports = __webpack_public_path__ + "img/NimbusMonoL-Bold.7cc30d9a.svg";